import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	selectedTheme: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	listRolesWithPermissions: [],
};

const roleSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setRolesData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingRoles: (state, action) => {
			state.loading = action.payload;
		},
		setSelectedTheme: (state, action) => {
			state.selectedClient = action.payload;
		},
		setAddRole: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setEditRole: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((unit) => (unit.id === id ? { ...unit, ...updatedData } : unit));
		},
		setDeleteRole: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
		},
		setClearRoles: (state) => {
			state.data = [];
		},
		setListRolesWithPermissions: (state, action) => {
			state.listRolesWithPermissions = action.payload || [];
		},
		setAllRolesListMore: (state, action) => {
			const data = action.payload;
			state.list = data || [];
		},
	},
});

export const {
	setRolesData,
	setLoadingRoles,
	setSelectedTheme,
	setAddRole,
	setEditRole,
	setDeleteRole,
	setClearRoles,
	setListRolesWithPermissions,
	setAllRolesListMore,
} = roleSlice.actions;
export default roleSlice.reducer;
